import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './userLogin/userLogin.component';
import { UserLogoutComponent } from './userLogout/userLogout.component';
import { TermsOfUseComponent } from './userRegister/termsofuse/termsofuse.component';
import { UserRegisterComponent } from './userRegister/userRegister.component';
import { UserVerifyComponent } from './userVerify/userVerify.component';
import { ForgotPasswordComponent } from './userForgotPassword/userForgotPassword.component';

const routes: Routes = [
    {path: 'login', component: UserLoginComponent},
    {path: 'signout', component: UserLogoutComponent},
    {path : 'userregister', component: UserRegisterComponent},
    {path : 'userverify', component: UserVerifyComponent},
    {path : 'termsofuse',component: TermsOfUseComponent},
	  {path : 'forgotpassword',component: ForgotPasswordComponent}	
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
